module.exports = __webpack_public_path__ + "static/img/far3.11457992.png";